import React from "react";
import { FaRegClock } from "react-icons/fa";
import { FiUserCheck } from "react-icons/fi";
import { strings } from "../../../strings/strings";

const AdminLoginMonitoring = ({ data }) => {

  const formatLoginDate = (dateString) => {
    if (!dateString) return strings.NOT_ADDED;

    const date = new Date(dateString);

    const time = date.toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
      second: "2-digit",
    });

    const fullDate = date.toLocaleDateString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });

    return `${fullDate} at ${time}`;
  };



  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 p-4">
      {/* Header */}
      <div className=" mb-4">
        <h2 className="text-xl font-bold text-gray-900 dark:text-white">{strings.ADMIN_MONITORING_TITLE}</h2>
      </div>

      {/* Login Info */}
      <div className="space-y-4">
        {/* Last Login */}
        <div className="flex items-center gap-3 p-4 bg-gray-100 dark:bg-gray-900/50 rounded-lg">
          <div className="flex-shrink-0 w-7 h-7 bg-blue-500 dark:bg-blue-600 rounded-lg flex items-center justify-center text-white">
            <FaRegClock className="w-4 h-4" />
          </div>
          <div className="flex items-start flex-col">
            <p className="text-sm text-gray-600 dark:text-gray-400">{strings.LAST_LOGIN}</p>
            <p className="text-sm text-gray-900 dark:text-white">{formatLoginDate(data?.lastLogin)}</p>
          </div>
        </div>

        {/* Logins This Week */}
        <div className="flex items-center gap-3 p-4 bg-gray-100 dark:bg-gray-900/50 rounded-lg">
          <div className="flex-shrink-0 w-7 h-7 bg-primary dark:bg-primary-dark rounded-lg flex items-center justify-center text-white">
            <FiUserCheck className="w-4 h-4" />
          </div>
          <div className="flex gap-1 items-center">
            <p className="text-sm text-gray-600 dark:text-gray-400">{strings.LOGINS_THIS_WEEK}</p>
            <p className="text-sm font-semibold text-gray-900 dark:text-white">{data?.weeklyLoginCount ?? '0'}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLoginMonitoring;
